import React, { useState, useEffect } from 'react';
import Wrapper from '../../components/Wrapper';
import { Box, Paper, Typography, TextField, Button, IconButton, Alert } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { widget } from '../../translate';
import RefreshIcon from '@mui/icons-material/Refresh';
import Api from '../../Api';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
export default function Widget() {
    const [ips, setIps] = useState(['']);
    const [iframeCode, setIframeCode] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
        Api.widgetGetIps().then(res => {
            setIps(res.data.ips);
        });
        Api.widgetEmbed().then(res => {
            setIframeCode(res.data);
        });
    }, []);

    const handleSave = () => {
        Api.widgetSaveIps(ips).then(res => {
           
        });
    }
    const handleRefresh = () => {
        Api.widgetRefresh().then(res => {
            setIframeCode(res.data);
        });
    }
    return (
        <Wrapper>
            <div className="tableParent">
                <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, borderBottom: '2px solid rgba(0, 0, 0, 0.08)', pb: 2.5, }}>
                        <IconButton
                            size="small"
                            sx={{ color: '#7ebc0a' }}
                            onClick={() => navigate(-1)}
                            aria-label="Back"
                        >
                            <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
                        </IconButton>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            {widget.title[+localStorage.getItem('atsLang') || 1] || 'Widget'}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Alert icon={<InfoIcon />} severity="success" sx={{ mb: 3 }}>
                            <Typography variant="body2">
                                {widget.ip_desc[+localStorage.getItem('atsLang') || 1]}
                            </Typography>
                        </Alert>
                        <Typography variant="subtitle2">{widget.allowed_ips[+localStorage.getItem('atsLang') || 1] || 'Allowed IPs'}</Typography>
                        {ips.map((ip, idx) => (
                            <Box key={idx} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <TextField
                                    value={ip}
                                    onChange={(e) => {
                                        const next = [...ips];
                                        next[idx] = e.target.value;
                                        setIps(next);
                                    }}
                                    placeholder="Enter IP address"
                                    size="small"
                                    sx={{
                                        maxWidth: 360,
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: '#7ebc0a' },
                                            '&:hover fieldset': { borderColor: '#6aa507' },
                                            '&.Mui-focused fieldset': { borderColor: '#7ebc0a' },
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': { color: '#7ebc0a' },
                                    }}
                                />
                                {ips.length > 1 && (
                                    <IconButton
                                        size="small"
                                        sx={{ color: '#7ebc0a' }}
                                        onClick={() => setIps(ips.filter((_, i) => i !== idx))}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        ))}
                        <Button
                            variant="text"
                            startIcon={<AddIcon />}
                            sx={{ color: '#7ebc0a', textTransform: 'none', alignSelf: 'flex-start' }}
                            onClick={() => setIps([...ips, ''])}
                        >
                            {widget.add_ip[+localStorage.getItem('atsLang') || 1] || 'Add IP'}
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            sx={{ alignSelf: 'flex-start', textTransform: 'none', backgroundColor: '#7ebc0a', '&:hover': { backgroundColor: '#6aa507' } }}
                            onClick={handleSave}
                        >
                            {widget.save_ips[+localStorage.getItem('atsLang') || 1] || 'Save IPs'}
                        </Button>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Alert icon={<InfoIcon />} severity="success" sx={{ mb: 3 }}>
                            <Typography variant="body2">
                                {widget.iframe_desc[+localStorage.getItem('atsLang') || 1]}
                            </Typography>
                        </Alert>
                        <TextField
                            value={iframeCode}
                            multiline
                            minRows={3}
                            size="small"
                            InputProps={{ readOnly: true }}
                            sx={{
                                fontFamily: 'monospace',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { borderColor: '#7ebc0a' },
                                    '&:hover fieldset': { borderColor: '#6aa507' },
                                    '&.Mui-focused fieldset': { borderColor: '#7ebc0a' },
                                },
                            }}
                        />
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                                size="small"
                                sx={{ color: '#7ebc0a', border: '1px solid #7ebc0a', borderRadius: 1, p: 1 }}
                                onClick={() => {
                                    navigator.clipboard?.writeText(iframeCode);
                                }}
                                aria-label="Copy iframe"
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                sx={{ color: '#7ebc0a', border: '1px solid #7ebc0a', borderRadius: 1, p: 1 }}
                                onClick={() => {
                                    handleRefresh();
                                }}
                                aria-label="Refresh iframe"
                            >
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Box>
                </Paper>
            </div>
        </Wrapper>
    );
}